import { __assign, __extends } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import { Modal as ROModal } from 'react-overlays';
import { ModalHeader } from '../ModalHeader';
import { ModalBody } from '../ModalBody';
import { ModalFooter } from '../ModalFooter';
var isModalHeader = function (node) {
    return typeof node.type === 'function' && node.type === ModalHeader;
};
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBackdrop = function (props) {
            var componentClass = 'modal';
            return React.createElement("div", __assign({}, props, { className: bcx(componentClass, 'backdrop') }));
        };
        return _this;
    }
    Modal.prototype.render = function () {
        var _a = this.props, show = _a.show, modalClose = _a.modalClose, children = _a.children, className = _a.className, fullHeight = _a.fullHeight, smThick = _a.smThick, id = _a.id, dataTestid = _a["data-testid"];
        var componentClass = 'modal';
        var classes = cx(bcx(componentClass, {
            'full-height': fullHeight,
            'sm-thick': smThick,
        }), componentClass, className);
        return (React.createElement(ROModal, { onHide: modalClose, className: classes, id: id, show: show, renderBackdrop: this.renderBackdrop },
            React.createElement("div", { className: "modal__dialog", "data-testid": dataTestid },
                React.createElement("div", { className: bcx('modal', 'content', { 'sm-thick': smThick }) }, React.Children.map(children, function (elem) {
                    if (!React.isValidElement(elem))
                        return elem;
                    return React.cloneElement(elem, {
                        onClose: isModalHeader(elem) ? modalClose : null,
                        smThick: isModalHeader(elem) ? smThick : undefined,
                    });
                })))));
    };
    Modal.defaultProps = {
        id: 'modal',
        fullHeight: false,
        smThick: false,
    };
    Modal.Header = ModalHeader;
    Modal.Body = ModalBody;
    Modal.Footer = ModalFooter;
    return Modal;
}(React.Component));
export { Modal };
//# sourceMappingURL=Modal.js.map